module.exports = __webpack_public_path__ + "img/png.6013a12c.png";